import { Component } from "preact";
import { css } from "emotion";

const checkEmptyIcon = require("../assets/ic_checkbox_empty.svg");
const checkFillIcon = require("../assets/ic_checkbox_fill.svg");

class CheckBox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { checkbox, checked, click, children } = this.props;
    const currentIcon = checked ? checkFillIcon : checkEmptyIcon;
    const wrapper = css({
      background: checkbox ? `url(${currentIcon}) no-repeat` : "none",
      backgroundPosition: "12px 10px",
      padding: "6px 12px",
      paddingLeft: checkbox ? "32px" : "12px",
      textAlign: "left",
      "&:hover": {
        backgroundColor: "#f9f9fa"
      }
    });
    return (
      <div
        className={wrapper}
        onClick={click}
        checked={checked}
        role="checkbox"
        tabIndex="0"
        onKeyPress={e => {
          if (e.keyCode === 32 || e.keyCode === 13) {
            e.stopPropagation();
            click();
          }
        }}
      >
        {children}
      </div>
    );
  }
}

export default CheckBox;
